// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profil-container {
  padding: 0;
  /* background: #fafafa; */
  min-height: 100vh;
}

.profil-container h1 {
  margin-bottom: 2rem;
}

.profil-tabs {
  margin-bottom: 2rem;
}

.profil-tab-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.5rem;
}

/* Toast autosave sous le section-header */
.autosave-toast-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 1.6rem;
  padding: 0.2rem 1rem 0.4rem;
  margin-top: -0.5rem;
  margin-bottom: 0.75rem;
}

/* section-header avec AutoSaveIndicator à droite */
.section-header--with-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-header--with-indicator .autosave-indicator {
  font-size: 0.8rem;
  font-weight: normal;
}

.section-header--with-indicator .autosave-pending,
.section-header--with-indicator .autosave-saving {
  color: rgba(255, 255, 255, 0.65);
}

.section-header--with-indicator .autosave-saved {
  color: #86efac;
}

.section-header--with-indicator .autosave-error {
  color: #fca5a5;
}

.section-header--with-indicator .autosave-spinner {
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: rgba(255, 255, 255, 0.8);
}

.profil-header {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

.profil-header .header-left h1 {
  font-weight: 700;
  margin: 0;
}

/* Completion sur UNE seule ligne a cote du titre : "Profil (XX%)" + barre fine + pastille,
   centres verticalement. Footprint vertical = celui du titre seul (compacite). */
.profil-header .header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

/* Pourcentage (hors titre) : a gauche de la ligne du badge. Couleur = celle du texte du badge. */
.profil-header-percent {
  font-size: 1.4rem;
  font-weight: 700;
}

.profil-header-percent.is-complete {
  color: #166534;
}

.profil-header-percent.is-partial {
  color: #c2410c;
}

.profil-header-percent.is-incomplete {
  color: #991b1b;
}

/* Groupe (largeur fixe) : ligne "% a gauche / badge a droite" au-dessus de la barre. */
.profil-header-completion {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 160px;
  margin-left: 1rem;
}

.profil-header-completion-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.profil-header-pastille {
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.25rem 0.85rem;
  border-radius: 9999px;
  white-space: nowrap;
}

.profil-header-pastille.is-complete {
  background: #dcfce7;
  color: #166534;
}

.profil-header-pastille.is-partial {
  background: #ffedd5;
  color: #c2410c;
}

.profil-header-pastille.is-incomplete {
  background: #fee2e2;
  color: #991b1b;
}

.profil-header-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
}

.profil-header-bar-fill {
  height: 100%;
  border-radius: 9999px;
  transition:
    width 0.5s ease-out,
    background-color 0.3s ease;
}

.profil-header .header-right {
  margin-left: auto;
  margin-top: 1rem;
}

/* .profil-container .logo-placeholder {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: rgba(215, 217, 217, 0.20);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
} */

.profil-container .profil-header h2 {
  font-size: 2.1rem;
  font-weight: 700;
}

/* .profil-container .section-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 0.7rem;
  border-bottom: 2px solid #222;
  padding-bottom: 0.3rem;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #E5E7EB;
} */

/* ── Rythme des formulaires de profil ────────────────────────────────────────────
   Aligne l'acheteur (Profil.tsx) ET le prestataire (ProfilUnifie.tsx -> TabPresentation),
   les deux rendant sous \`.profil-container\`. Valeurs reprises telles quelles du descriptif
   administratif des consultations (\`.bcadm-desc__grid\`, \`.opms__admin-grid\`) : meme gouttiere,
   meme ecart label/champ, meme box-model. C'est le rendu de reference de l'application.

   Ce qui rendait le profil illisible : trois mecanismes d'espacement se superposaient sans
   s'accorder — \`margin-bottom: 0.5rem\` ici, \`gap: 1rem\` + \`margin-bottom: 0.75rem\` sur
   \`.form-row\` (TabPresentation.css), et \`gap: 0.375rem\` entre label et champ. L'ecart entre
   deux rangees finissait plus petit que l'ecart entre un label et son champ : les champs ne se
   groupaient plus visuellement, tout se lisait comme une seule colonne indifferenciee.

   Decomposition identique a la reference : 2rem portes par le champ + 1.2rem de gouttiere =
   3.2rem entre deux rangees, 2rem sous un champ isole, 2rem de gouttiere horizontale.
   Toutes les regles sont prefixees \`.profil-container\` (0,2,x) pour battre de facon
   deterministe les declarations \`.form-group\` / \`.form-row\` non scopees qui trainent dans
   neuf feuilles de style — sans en ajouter une dixieme. */
.profil-container .form-group {
  margin-bottom: 2rem;
  /* TabPresentation passe \`.form-group\` en flex column avec \`gap: 0.375rem\`, qui s'ADDITIONNE a
     la marge du label. On neutralise la gouttiere : l'ecart label/champ doit venir du seul
     \`margin-bottom\` du label, comme en consultation. Le flex est conserve — le repasser en
     \`block\` changerait le flux des enfants inline (messages d'erreur, compteurs). */
  gap: 0;
}

/* Nombre de colonnes RE-AFFIRME ici. \`.form-row\` et ses modificateurs (\`grid-4\`, \`three-cols\`)
   pesent tous 0,1,0 : a egalite de specificite, c'est l'ordre de chargement des feuilles qui
   tranchait, et une rangee demandee en 4 colonnes pouvait sortir en 2 selon le bundle. Prefixe
   par \`.profil-container\` (0,2,0), le resultat ne depend plus de l'ordre. Les valeurs sont celles
   deja voulues par le markup, rien ne change a l'ecran. */
.profil-container .form-row {
  grid-template-columns: repeat(2, 1fr);
}

.profil-container .form-row.three-cols {
  grid-template-columns: repeat(3, 1fr);
}

.profil-container .form-row.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}

.profil-container .form-row.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.profil-container .form-row {
  row-gap: 1.2rem;
  column-gap: 2rem;
  /* Sans ceci, une rangee dont un champ est plus haut (textarea, message d'erreur) etire les
     autres et casse l'alignement des libelles. */
  align-items: start;
  /* Deux \`.form-row\` sont des freres, pas des elements d'une meme grille : la gouttiere ne les
     separe pas. Cette marge la rejoue pour que l'ecart inter-rangees vaille celui d'une rangee
     qui passe a la ligne. */
  margin-bottom: 1.2rem;
}

.profil-container .form-group label,
.profil-container .form-group .label {
  display: block;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
}

/* Champs saisis ET lecture seule au meme gabarit : sans \`min-height\` commune, une rangee melant
   les deux presente des hauteurs differentes et les libelles cessent de s'aligner.

   \`:not(...)\` : certains \`.form-group\` contiennent une case a cocher ou un interrupteur
   (\`Switch\` sur le redressement judiciaire, acceptation des conditions) et non un champ texte.
   Leur imposer \`width: 100%\` et une hauteur minimale de 4.6rem etirerait la case sur toute la
   largeur de la colonne. Le gabarit ne vaut que pour les champs de saisie. */
.profil-container .form-group input:not([type='checkbox']):not([type='radio']):not([type='file']),
.profil-container .form-group select,
.profil-container .form-group textarea,
.profil-container .form-group .input-inactif {
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem;
  border-radius: 10px;
  font-size: 1.6rem;
  line-height: 1.4;
}

.profil-container .form-group input:not([type='checkbox']):not([type='radio']):not([type='file']),
.profil-container .form-group select,
.profil-container .form-group .input-inactif {
  min-height: 4.6rem;
}

.profil-container .button-container {
  margin-top: 1.2rem;
}

.gestion-comptes-compact {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.profil-documents-page {
  padding: 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  margin-bottom: 0;
}

.mes-documents {
  padding: 0;
  max-width: 100%;
  margin: 0;
}

/* .document-section {
  background: #FFFDFC;
  padding: 2rem;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(44,57,72,0.04);
} */

.document-name {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
}

.add-document-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.profil-tab-page .button-container {
  display: flex;
  justify-content: flex-end;
}

/* Style pour le tooltip des onglets inactifs */
.profil-tabs .tab-button.inactive {
  position: relative;
}

.profil-tabs .tab-button.inactive:hover::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(
    100% + 10px
  ); /* Position au-dessus de l'onglet avec un peu d'espace */
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  visibility: visible;
  opacity: 1;
  z-index: 100;
}

/* Flèche du tooltip */
.profil-tabs .tab-button.inactive:hover::after {
  content: "";
  position: absolute;
  bottom: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
  visibility: visible;
  opacity: 1;
}

/* Style pour le message "Fonctionnalité à venir" */
.coming-soon-message {
  text-align: center;
  padding: 3rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-radius: 8px;
  margin: 2rem 0;
  border-left: 4px solid #f97316;
}

.coming-soon-message h2 {
  color: #2c3948;
  margin-bottom: 1rem;
}

.coming-soon-message p {
  color: #6b7280;
  font-size: 1.6rem;
}

/* Onglet "Statistiques et besoins" - section informative (icone a gauche, texte a droite) */
.stats-besoins-notice {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.25rem;
  margin: 2rem 0;
  background-color: rgba(215, 217, 217, 0.2);
  border-left: 4px solid #f97316;
  border-radius: 8px;
}

.stats-besoins-notice-icon {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  margin-top: 0.1rem;
  fill: #f97316;
}

.stats-besoins-notice-text {
  margin: 0;
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.6;
}

/* Bandeau "Derniere mise a jour" - fond vert / texte vert fonce (hors palette fermee, demande explicite) */
.stats-besoins-maj {
  margin: 0 0 2rem 0;
  padding: 0.75rem 1.25rem;
  background-color: #dcfce7;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}

.stats-besoins-maj-text {
  margin: 0;
  color: #166534;
  font-size: 1.3rem;
  font-weight: 500;
}

/* Section "Synthese annuelle et evaluation du besoin" - bandeau gris #595959
   (idiome FRONT-15 replique en local pour ne pas dependre d'un CSS d'onglet non monte) */
.synthese-besoins-block {
  margin: 0 0 2rem 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.synthese-besoins-banner {
  padding: 1.25rem 1.5rem;
  background-color: #595959;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
}

.synthese-besoins-content {
  padding: 1.5rem;
  background: #fff;
}

/* 7 cartes sur une seule ligne : icone (placeholder) en haut, titre, puis valeur */
.synthese-cards {
  display: flex;
  gap: 1rem;
}

.synthese-card {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  padding: 1.25rem 0.75rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

.synthese-card-icon {
  width: 3.2rem;
  height: 3.2rem;
  object-fit: contain;
  flex-shrink: 0;
}

.synthese-card-titre {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}

.synthese-card-valeur {
  font-size: 1.6rem;
  font-weight: 700;
  color: #374151;
  word-break: break-word;
}

/* Chiffre de l'annee precedente (N-1) : gris, plus petit, sous la valeur en cours. */
.synthese-card-valeur-n1 {
  display: block;
  margin-top: 0.2rem;
  font-size: 1.15rem;
  font-weight: 600;
  color: #9ca3af;
  word-break: break-word;
}

/* Skeleton de chargement (idiome Annuaire) - uniquement sur la valeur des cartes dynamiques */
.synthese-card-skeleton {
  display: block;
  width: 70%;
  height: 1.6rem;
  border-radius: 4px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: synthese-sk-shimmer 1.4s ease-in-out infinite;
  pointer-events: none;
}

/* Skeleton du chiffre N-1 : plus petit/court, sous le skeleton de la valeur en cours. */
.synthese-card-skeleton-n1 {
  width: 45%;
  height: 1.15rem;
  margin-top: 0.3rem;
}

@keyframes synthese-sk-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.identifiant-connexion {
  margin-bottom: 2rem !important;
}

.identifiant-connexion-input {
  display: flex;
}

.identifiant-connexion-input > button {
  width: 419px;
  margin-left: 1rem;
}

/* Styles pour la modal de modification */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  /* padding: 24px; */
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content h2 {
  margin-top: 0;
  margin-bottom: 24px;
  color: #333;
}

.modal-content .form-group {
  margin-bottom: 16px;
}

.modal-content label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.modal-content input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-content .input-inactif {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.modal-content .input-error {
  border-color: #dc3545;
}

.modal-content .error-message {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.section-content-scrollable {
  overflow-y: auto;
  height: 86%;
}

/* Detail du perimetre geographique (onglet Statistiques et besoins) */
.perimetre-detail {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.perimetre-detail-empty {
  font-size: 1.4rem;
  color: #6b7280;
  font-style: italic;
}

.perimetre-detail-group {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.perimetre-detail-label {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.perimetre-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.perimetre-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 1rem;
  border-radius: 999px;
  font-size: 1.3rem;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.perimetre-chip--region {
  background: #fff7ed;
  color: #c2410c;
  border-color: #fed7aa;
  font-weight: 600;
}

.perimetre-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.6rem 1.25rem;
  border-radius: 0.6rem;
  font-size: 1.4rem;
  font-weight: 600;
}

.perimetre-badge--national {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.representant-label {
  margin: 0 0 1rem 0;
  font-size: 1.4rem;
  font-weight: 600;
}
/* Carte "Périmètre" de la Synthèse annuelle : tooltip de détail au survol */
.synthese-card--perimetre {
  cursor: help;
}

.perimetre-stat-tooltip {
  position: fixed;
  z-index: 4000;
  min-width: 26rem;
  max-width: 34rem;
  padding: 1.25rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  text-align: left;
  pointer-events: none;
}

.perimetre-stat-tooltip-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #111827;
  margin-bottom: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/Profil.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;iFACiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,iGAAiG;AACjG;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB;;8BAE4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;;;;;;;;;;;;;;;;0DAgB0D;AAC1D;EACE,mBAAmB;EACnB;;;oFAGkF;EAClF,MAAM;AACR;;AAEA;;;;0DAI0D;AAC1D;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;iDAC+C;EAC/C,kBAAkB;EAClB;;4BAE0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;6EAM6E;AAC7E;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB;;GAEC,EAAE,wDAAwD;EAC3D,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,mBAAmB;EACnB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,4FAA4F;AAC5F;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2GAA2G;AAC3G;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;yFACyF;AACzF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,qFAAqF;AACrF;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,8FAA8F;AAC9F;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA,wFAAwF;AACxF;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,4EAA4E;AAC5E;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".profil-container {\r\n  padding: 0;\r\n  /* background: #fafafa; */\r\n  min-height: 100vh;\r\n}\r\n\r\n.profil-container h1 {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.profil-tabs {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.profil-tab-header {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n/* Toast autosave sous le section-header */\r\n.autosave-toast-bar {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  min-height: 1.6rem;\r\n  padding: 0.2rem 1rem 0.4rem;\r\n  margin-top: -0.5rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n/* section-header avec AutoSaveIndicator à droite */\r\n.section-header--with-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.section-header--with-indicator .autosave-indicator {\r\n  font-size: 0.8rem;\r\n  font-weight: normal;\r\n}\r\n\r\n.section-header--with-indicator .autosave-pending,\r\n.section-header--with-indicator .autosave-saving {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.section-header--with-indicator .autosave-saved {\r\n  color: #86efac;\r\n}\r\n\r\n.section-header--with-indicator .autosave-error {\r\n  color: #fca5a5;\r\n}\r\n\r\n.section-header--with-indicator .autosave-spinner {\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n  border-top-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.profil-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.profil-header .header-left h1 {\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n/* Completion sur UNE seule ligne a cote du titre : \"Profil (XX%)\" + barre fine + pastille,\r\n   centres verticalement. Footprint vertical = celui du titre seul (compacite). */\r\n.profil-header .header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Pourcentage (hors titre) : a gauche de la ligne du badge. Couleur = celle du texte du badge. */\r\n.profil-header-percent {\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.profil-header-percent.is-complete {\r\n  color: #166534;\r\n}\r\n\r\n.profil-header-percent.is-partial {\r\n  color: #c2410c;\r\n}\r\n\r\n.profil-header-percent.is-incomplete {\r\n  color: #991b1b;\r\n}\r\n\r\n/* Groupe (largeur fixe) : ligne \"% a gauche / badge a droite\" au-dessus de la barre. */\r\n.profil-header-completion {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  width: 160px;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.profil-header-completion-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.profil-header-pastille {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  padding: 0.25rem 0.85rem;\r\n  border-radius: 9999px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.profil-header-pastille.is-complete {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n}\r\n\r\n.profil-header-pastille.is-partial {\r\n  background: #ffedd5;\r\n  color: #c2410c;\r\n}\r\n\r\n.profil-header-pastille.is-incomplete {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n}\r\n\r\n.profil-header-bar {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: #e5e7eb;\r\n  border-radius: 9999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.profil-header-bar-fill {\r\n  height: 100%;\r\n  border-radius: 9999px;\r\n  transition:\r\n    width 0.5s ease-out,\r\n    background-color 0.3s ease;\r\n}\r\n\r\n.profil-header .header-right {\r\n  margin-left: auto;\r\n  margin-top: 1rem;\r\n}\r\n\r\n/* .profil-container .logo-placeholder {\r\n  width: 110px;\r\n  height: 110px;\r\n  border-radius: 50%;\r\n  background: rgba(215, 217, 217, 0.20);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n} */\r\n\r\n.profil-container .profil-header h2 {\r\n  font-size: 2.1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* .profil-container .section-title {\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  margin-bottom: 0.7rem;\r\n  border-bottom: 2px solid #222;\r\n  padding-bottom: 0.3rem;\r\n  margin-top: 3rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #E5E7EB;\r\n} */\r\n\r\n/* ── Rythme des formulaires de profil ────────────────────────────────────────────\r\n   Aligne l'acheteur (Profil.tsx) ET le prestataire (ProfilUnifie.tsx -> TabPresentation),\r\n   les deux rendant sous `.profil-container`. Valeurs reprises telles quelles du descriptif\r\n   administratif des consultations (`.bcadm-desc__grid`, `.opms__admin-grid`) : meme gouttiere,\r\n   meme ecart label/champ, meme box-model. C'est le rendu de reference de l'application.\r\n\r\n   Ce qui rendait le profil illisible : trois mecanismes d'espacement se superposaient sans\r\n   s'accorder — `margin-bottom: 0.5rem` ici, `gap: 1rem` + `margin-bottom: 0.75rem` sur\r\n   `.form-row` (TabPresentation.css), et `gap: 0.375rem` entre label et champ. L'ecart entre\r\n   deux rangees finissait plus petit que l'ecart entre un label et son champ : les champs ne se\r\n   groupaient plus visuellement, tout se lisait comme une seule colonne indifferenciee.\r\n\r\n   Decomposition identique a la reference : 2rem portes par le champ + 1.2rem de gouttiere =\r\n   3.2rem entre deux rangees, 2rem sous un champ isole, 2rem de gouttiere horizontale.\r\n   Toutes les regles sont prefixees `.profil-container` (0,2,x) pour battre de facon\r\n   deterministe les declarations `.form-group` / `.form-row` non scopees qui trainent dans\r\n   neuf feuilles de style — sans en ajouter une dixieme. */\r\n.profil-container .form-group {\r\n  margin-bottom: 2rem;\r\n  /* TabPresentation passe `.form-group` en flex column avec `gap: 0.375rem`, qui s'ADDITIONNE a\r\n     la marge du label. On neutralise la gouttiere : l'ecart label/champ doit venir du seul\r\n     `margin-bottom` du label, comme en consultation. Le flex est conserve — le repasser en\r\n     `block` changerait le flux des enfants inline (messages d'erreur, compteurs). */\r\n  gap: 0;\r\n}\r\n\r\n/* Nombre de colonnes RE-AFFIRME ici. `.form-row` et ses modificateurs (`grid-4`, `three-cols`)\r\n   pesent tous 0,1,0 : a egalite de specificite, c'est l'ordre de chargement des feuilles qui\r\n   tranchait, et une rangee demandee en 4 colonnes pouvait sortir en 2 selon le bundle. Prefixe\r\n   par `.profil-container` (0,2,0), le resultat ne depend plus de l'ordre. Les valeurs sont celles\r\n   deja voulues par le markup, rien ne change a l'ecran. */\r\n.profil-container .form-row {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.profil-container .form-row.three-cols {\r\n  grid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.profil-container .form-row.grid-2 {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.profil-container .form-row.grid-4 {\r\n  grid-template-columns: repeat(4, 1fr);\r\n}\r\n\r\n.profil-container .form-row {\r\n  row-gap: 1.2rem;\r\n  column-gap: 2rem;\r\n  /* Sans ceci, une rangee dont un champ est plus haut (textarea, message d'erreur) etire les\r\n     autres et casse l'alignement des libelles. */\r\n  align-items: start;\r\n  /* Deux `.form-row` sont des freres, pas des elements d'une meme grille : la gouttiere ne les\r\n     separe pas. Cette marge la rejoue pour que l'ecart inter-rangees vaille celui d'une rangee\r\n     qui passe a la ligne. */\r\n  margin-bottom: 1.2rem;\r\n}\r\n\r\n.profil-container .form-group label,\r\n.profil-container .form-group .label {\r\n  display: block;\r\n  margin-bottom: 0.8rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  color: #2c3948;\r\n}\r\n\r\n/* Champs saisis ET lecture seule au meme gabarit : sans `min-height` commune, une rangee melant\r\n   les deux presente des hauteurs differentes et les libelles cessent de s'aligner.\r\n\r\n   `:not(...)` : certains `.form-group` contiennent une case a cocher ou un interrupteur\r\n   (`Switch` sur le redressement judiciaire, acceptation des conditions) et non un champ texte.\r\n   Leur imposer `width: 100%` et une hauteur minimale de 4.6rem etirerait la case sur toute la\r\n   largeur de la colonne. Le gabarit ne vaut que pour les champs de saisie. */\r\n.profil-container .form-group input:not([type='checkbox']):not([type='radio']):not([type='file']),\r\n.profil-container .form-group select,\r\n.profil-container .form-group textarea,\r\n.profil-container .form-group .input-inactif {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 1.2rem;\r\n  border-radius: 10px;\r\n  font-size: 1.6rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.profil-container .form-group input:not([type='checkbox']):not([type='radio']):not([type='file']),\r\n.profil-container .form-group select,\r\n.profil-container .form-group .input-inactif {\r\n  min-height: 4.6rem;\r\n}\r\n\r\n.profil-container .button-container {\r\n  margin-top: 1.2rem;\r\n}\r\n\r\n.gestion-comptes-compact {\r\n  padding-left: 0.5rem !important;\r\n  padding-right: 0.5rem !important;\r\n  padding-top: 1rem !important;\r\n  padding-bottom: 1rem !important;\r\n}\r\n\r\n.profil-documents-page {\r\n  padding: 0;\r\n  background: none;\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mes-documents {\r\n  padding: 0;\r\n  max-width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n/* .document-section {\r\n  background: #FFFDFC;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: 0 2px 8px rgba(44,57,72,0.04);\r\n} */\r\n\r\n.document-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.add-document-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.profil-tab-page .button-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Style pour le tooltip des onglets inactifs */\r\n.profil-tabs .tab-button.inactive {\r\n  position: relative;\r\n}\r\n\r\n.profil-tabs .tab-button.inactive:hover::before {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: calc(\r\n    100% + 10px\r\n  ); /* Position au-dessus de l'onglet avec un peu d'espace */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 8px 12px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  visibility: visible;\r\n  opacity: 1;\r\n  z-index: 100;\r\n}\r\n\r\n/* Flèche du tooltip */\r\n.profil-tabs .tab-button.inactive:hover::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: calc(100% + 5px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n/* Style pour le message \"Fonctionnalité à venir\" */\r\n.coming-soon-message {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  border-radius: 8px;\r\n  margin: 2rem 0;\r\n  border-left: 4px solid #f97316;\r\n}\r\n\r\n.coming-soon-message h2 {\r\n  color: #2c3948;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.coming-soon-message p {\r\n  color: #6b7280;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n/* Onglet \"Statistiques et besoins\" - section informative (icone a gauche, texte a droite) */\r\n.stats-besoins-notice {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  padding: 1rem 1.25rem;\r\n  margin: 2rem 0;\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  border-left: 4px solid #f97316;\r\n  border-radius: 8px;\r\n}\r\n\r\n.stats-besoins-notice-icon {\r\n  flex-shrink: 0;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  margin-top: 0.1rem;\r\n  fill: #f97316;\r\n}\r\n\r\n.stats-besoins-notice-text {\r\n  margin: 0;\r\n  color: #374151;\r\n  font-size: 1.4rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Bandeau \"Derniere mise a jour\" - fond vert / texte vert fonce (hors palette fermee, demande explicite) */\r\n.stats-besoins-maj {\r\n  margin: 0 0 2rem 0;\r\n  padding: 0.75rem 1.25rem;\r\n  background-color: #dcfce7;\r\n  border: 1px solid #bbf7d0;\r\n  border-radius: 8px;\r\n}\r\n\r\n.stats-besoins-maj-text {\r\n  margin: 0;\r\n  color: #166534;\r\n  font-size: 1.3rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Section \"Synthese annuelle et evaluation du besoin\" - bandeau gris #595959\r\n   (idiome FRONT-15 replique en local pour ne pas dependre d'un CSS d'onglet non monte) */\r\n.synthese-besoins-block {\r\n  margin: 0 0 2rem 0;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.synthese-besoins-banner {\r\n  padding: 1.25rem 1.5rem;\r\n  background-color: #595959;\r\n  color: #fff;\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.synthese-besoins-content {\r\n  padding: 1.5rem;\r\n  background: #fff;\r\n}\r\n\r\n/* 7 cartes sur une seule ligne : icone (placeholder) en haut, titre, puis valeur */\r\n.synthese-cards {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.synthese-card {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 0.5rem;\r\n  padding: 1.25rem 0.75rem;\r\n  background: #f3f4f6;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.synthese-card-icon {\r\n  width: 3.2rem;\r\n  height: 3.2rem;\r\n  object-fit: contain;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.synthese-card-titre {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: #595959;\r\n}\r\n\r\n.synthese-card-valeur {\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n  color: #374151;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Chiffre de l'annee precedente (N-1) : gris, plus petit, sous la valeur en cours. */\r\n.synthese-card-valeur-n1 {\r\n  display: block;\r\n  margin-top: 0.2rem;\r\n  font-size: 1.15rem;\r\n  font-weight: 600;\r\n  color: #9ca3af;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Skeleton de chargement (idiome Annuaire) - uniquement sur la valeur des cartes dynamiques */\r\n.synthese-card-skeleton {\r\n  display: block;\r\n  width: 70%;\r\n  height: 1.6rem;\r\n  border-radius: 4px;\r\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\r\n  background-size: 200% 100%;\r\n  animation: synthese-sk-shimmer 1.4s ease-in-out infinite;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Skeleton du chiffre N-1 : plus petit/court, sous le skeleton de la valeur en cours. */\r\n.synthese-card-skeleton-n1 {\r\n  width: 45%;\r\n  height: 1.15rem;\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n@keyframes synthese-sk-shimmer {\r\n  0% { background-position: -200% 0; }\r\n  100% { background-position: 200% 0; }\r\n}\r\n\r\n.identifiant-connexion {\r\n  margin-bottom: 2rem !important;\r\n}\r\n\r\n.identifiant-connexion-input {\r\n  display: flex;\r\n}\r\n\r\n.identifiant-connexion-input > button {\r\n  width: 419px;\r\n  margin-left: 1rem;\r\n}\r\n\r\n/* Styles pour la modal de modification */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 8px;\r\n  /* padding: 24px; */\r\n  width: 500px;\r\n  max-width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-content h2 {\r\n  margin-top: 0;\r\n  margin-bottom: 24px;\r\n  color: #333;\r\n}\r\n\r\n.modal-content .form-group {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.modal-content label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n}\r\n\r\n.modal-content input {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.modal-content .input-inactif {\r\n  background-color: #f5f5f5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-content .input-error {\r\n  border-color: #dc3545;\r\n}\r\n\r\n.modal-content .error-message {\r\n  color: #dc3545;\r\n  font-size: 0.85rem;\r\n  margin-top: 4px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.section-content-scrollable {\r\n  overflow-y: auto;\r\n  height: 86%;\r\n}\r\n\r\n/* Detail du perimetre geographique (onglet Statistiques et besoins) */\r\n.perimetre-detail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n}\r\n\r\n.perimetre-detail-empty {\r\n  font-size: 1.4rem;\r\n  color: #6b7280;\r\n  font-style: italic;\r\n}\r\n\r\n.perimetre-detail-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.perimetre-detail-label {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.perimetre-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.perimetre-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.45rem 1rem;\r\n  border-radius: 999px;\r\n  font-size: 1.3rem;\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.perimetre-chip--region {\r\n  background: #fff7ed;\r\n  color: #c2410c;\r\n  border-color: #fed7aa;\r\n  font-weight: 600;\r\n}\r\n\r\n.perimetre-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.6rem 1.25rem;\r\n  border-radius: 0.6rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.perimetre-badge--national {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  border: 1px solid #bbf7d0;\r\n}\r\n\r\n.representant-label {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n}\r\n/* Carte \"Périmètre\" de la Synthèse annuelle : tooltip de détail au survol */\r\n.synthese-card--perimetre {\r\n  cursor: help;\r\n}\r\n\r\n.perimetre-stat-tooltip {\r\n  position: fixed;\r\n  z-index: 4000;\r\n  min-width: 26rem;\r\n  max-width: 34rem;\r\n  padding: 1.25rem;\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.8rem;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n  text-align: left;\r\n  pointer-events: none;\r\n}\r\n\r\n.perimetre-stat-tooltip-title {\r\n  font-weight: 700;\r\n  font-size: 1.4rem;\r\n  color: #111827;\r\n  margin-bottom: 0.75rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
